import { Directive } from '@angular/core';
import { GtmImpressionTrackDirectiveDef } from '@df/module-gtm/gtm-impression-track.directive.def';

@Directive({
    selector: '[gtmImpressionTrack]',
    standalone: true
})
export class GtmImpressionTrackDirective extends GtmImpressionTrackDirectiveDef {}
